import React from "react";

const NumberOfItems = ({ count }) => {
  return <p className="number-of-items">{count}</p>;
};

export default NumberOfItems;
